<div class="flex flex-1 gap-2 mb-2">
  <div class="relative flex items-center mr-2 flex-1">
    <input
      type="text"
      pInputText
      [value]="searchText"
      (input)="onSearchChange($event)"
      placeholder="Behörde suchen"
      spellcheck="false"
      autocomplete="off"
      class="w-full pr-8 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary-500"
    />
    @if (searchText) {
      <i
        class="pi pi-times absolute right-2 cursor-pointer text-gray-400 hover:text-gray-700"
        (click)="clearSearch()">
      </i>
    }
  </div>
  <p-button
    label="Neue Behörde"
    iconPos="left"
    icon="pi pi-plus"
    (click)="toggleCreateModal(true)"
  />
</div>

<app-alphabet-filter
  [alphabet]="alphabet"
  [groups]="groupedAuthorities"
  [selectedLetter]="selectedLetter"
  [disabled]="searchedAuthorities.length > 0"
  (letterSelected)="filterByLetter($event)"
/>

<div class="flex flex-col flex-1 min-h-0">
  <div class="flex-shrink-0 bg-primary-600 text-white font-bold px-4 py-2 rounded mb-1 text-sm">
    <div class="flex">
      <span class="flex-1 text-left">{{ 'general.competentAuthority' | transloco }}</span>
      <span class="flex-1 text-left">{{ 'contacts.address' | transloco }}</span>
      <span class="flex-1 text-left">{{ 'contacts.phoneNumber' | transloco }}</span>
      <span class="flex-1 text-left">{{ 'contacts.email' | transloco }}</span>
      <span class="flex-1"></span>
    </div>
  </div>
  @if (isLoading) {
    <div class="flex w-full items-center justify-center gap-2 py-2 text-gray-500">
      <i class="pi pi-spinner pi-spin"></i>
      <span>Kontakte werden geladen...</span>
    </div>
  }
  <div class="flex flex-grow overflow-hidden h-[515px]">
    <p-scroller
        #scroller
        [items]="visibleAuthorities"
        [itemSize]="50"
        [trackBy]="trackByAuthority"
        class="w-full h-[515px]"
    >
      <ng-template let-authority pTemplate="item">
        <div
          class="flex items-center gap-2 px-4 py-3 border-b text-sm cursor-pointer transition-colors hover:bg-gray-50"
          [id]="'authority-' + authority.id"
          [ngClass]="{ 'bg-secondary-100': highlightedAuthorityId === authority.id }"
          (click)="toggleEditModal(true, authority)">
          <i class="pi pi-briefcase text-primary-600 text-lg flex-shrink-0"></i>
          <span class="flex-1 text-left">{{ authority.name || '-' }}</span>
          <span class="flex-1 text-left">{{ formatAddress(authority.contacts?.[0]) }}</span>
          <span class="flex-1 text-left">{{ authority.contacts?.[0]?.phoneNumber || '-' }}</span>
          <span class="flex-1 text-left">{{ authority.contacts?.[0]?.email || '-' }}</span>
          <span class="flex flex-1 justify-end"><i class="pi pi-pen-to-square"></i></span>
        </div>
      </ng-template>
    </p-scroller>
  </div>

  <app-competent-authority-create-dialog
    [(visible)]="showCompetentAuthorityDialog"
    (created)="onCompetentAuthorityCreated($event)"
  />

  <app-competent-authority-edit-dialog
    [(visible)]="openEditModal"
    [authority]="newAuthority"
    (updated)="onCompetentAuthorityUpdated($event)"
  />
</div>
